import moment from "moment"

function ChartDataConverter(params,color='blue',formatOutput='MMM', formatInput='YY-MM') {
    const values = Object.entries(params)
    var minValue = 0
    var maxValue = 0
    values.sort((a, b) => {
        if (a[1] < b[1] && a[1]<minValue) {
            minValue = a[1]
        }
        if (a[1] > b[1] && a[1]>maxValue) {
            maxValue= a[1]
        }
        if (a[0] < b[0] ) {
          return -1;
        }
        if (a[0] > b[0]) {
          return 1;
        }
        // a debe ser igual b
        return 0;
      })
    let chartExample2 = {
        data: (canvas) => {
          let ctx = canvas.getContext("2d");
      
          let gradientStroke = ctx.createLinearGradient(0, 230, 0, 50);
      
          gradientStroke.addColorStop(1, "rgba(29,140,248,0.2)");
          gradientStroke.addColorStop(0.4, "rgba(29,140,248,0.0)");
          gradientStroke.addColorStop(0, "rgba(29,140,248,0)"); //blue colors
          var pointBackgroundColor= "#1f8ef1";
          var pointBorderColor= "rgba(255,255,255,0)";
          var pointHoverBackgroundColor= "#1f8ef1";
          if(color==='green') {
            
            gradientStroke = ctx.createLinearGradient(0, 230, 0, 50);

            gradientStroke.addColorStop(1, "rgba(66,134,121,0.15)");
            gradientStroke.addColorStop(0.4, "rgba(66,134,121,0.0)"); //green colors
            gradientStroke.addColorStop(0, "rgba(66,134,121,0)"); //green colors
            pointBackgroundColor= "#00d6b4";
            pointBorderColor= "rgba(255,255,255,0)";
            pointHoverBackgroundColor= "#00d6b4";
          }
      
          return {
            labels: values.map((item)=>{
                const dateformate= moment(item[0], formatInput)
                return dateformate.format(formatOutput)
            }),
            datasets: [
              {
                label: "Data",
                fill: true,
                backgroundColor: gradientStroke,
                borderColor: pointHoverBackgroundColor,
                borderWidth: 2,
                borderDash: [],
                borderDashOffset: 0.0,
                pointBackgroundColor,
                pointBorderColor,
                pointHoverBackgroundColor,
                pointBorderWidth: 20,
                pointHoverRadius: 4,
                pointHoverBorderWidth: 15,
                pointRadius: 4,
                data: values.map((item)=>{
                    return item[1]
                }),
              },
            ],
          };
        },
        options: {
          maintainAspectRatio: false,
          legend: {
            display: false,
          },
          tooltips: {
            backgroundColor: "#f5f5f5",
            titleFontColor: "#333",
            bodyFontColor: "#666",
            bodySpacing: 4,
            xPadding: 12,
            mode: "nearest",
            intersect: 0,
            position: "nearest",
          },
          responsive: true,
          scales: {
            yAxes: [
              {
                barPercentage: 1.6,
                gridLines: {
                  drawBorder: false,
                  color: "rgba(29,140,248,0.0)",
                  zeroLineColor: "transparent",
                },
                ticks: {
                  suggestedMin: minValue,
                  suggestedMax: maxValue,
                  padding: 20,
                  fontColor: "#9a9a9a",
                },
              },
            ],
            xAxes: [
              {
                barPercentage: 1.6,
                gridLines: {
                  drawBorder: false,
                  color: "rgba(29,140,248,0.1)",
                  zeroLineColor: "transparent",
                },
                ticks: {
                  padding: 20,
                  fontColor: "#9a9a9a",
                },
              },
            ],
          },
        },
      };
      return chartExample2
}
export function ChartDataConverterBars(params,color='blue') {
    const values = Object.entries(params)
    var minValue = 0
    var maxValue = 0
    values.sort((a, b) => {
        if (a[1] < b[1] && a[1]<minValue) {
            minValue = a[1]
        }
        if (a[1] > b[1] && a[1]>maxValue) {
            maxValue= a[1]
        }
        if (a[0] < b[0] ) {
          return -1;
        }
        if (a[0] > b[0]) {
          return 1;
        }
        // a debe ser igual b
        return 0;
      })
    let chartExample2 = {
      data: (canvas) => {
        let ctx = canvas.getContext("2d");
    
        let gradientStroke = ctx.createLinearGradient(0, 230, 0, 50);
    
        gradientStroke.addColorStop(1, "rgba(72,72,176,0.1)");
        gradientStroke.addColorStop(0.4, "rgba(72,72,176,0.0)");
        gradientStroke.addColorStop(0, "rgba(119,52,169,0)"); //purple colors
    
        return {
          labels: values.map((item)=>{
            return item[0]
          }),
          datasets: [
            {
              label: "Data",
              fill: true,
              backgroundColor: gradientStroke,
              hoverBackgroundColor: gradientStroke,
              borderColor: "#d048b6",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              data: values.map((item)=>{
                return item[1]
            }),
            },
          ],
        };
      },
      options: {
        maintainAspectRatio: false,
        legend: {
          display: false,
        },
        tooltips: {
          backgroundColor: "#f5f5f5",
          titleFontColor: "#333",
          bodyFontColor: "#666",
          bodySpacing: 4,
          xPadding: 12,
          mode: "nearest",
          intersect: 0,
          position: "nearest",
        },
        responsive: true,
        scales: {
          yAxes: [
            {
              gridLines: {
                drawBorder: false,
                color: "rgba(225,78,202,0.1)",
                zeroLineColor: "transparent",
              },
              ticks: {
                suggestedMin: minValue,
                suggestedMax: maxValue,
                padding: 20,
                fontColor: "#9e9e9e",
              },
            },
          ],
          xAxes: [
            {
              gridLines: {
                drawBorder: false,
                color: "rgba(225,78,202,0.1)",
                zeroLineColor: "transparent",
              },
              ticks: {
                padding: 20,
                fontColor: "#9e9e9e",
              },
            },
          ],
        },
      },
    };
      return chartExample2
}
export default ChartDataConverter